import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Lock } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "@/components/Reveal";

const Piece = ({ src, title, tag, cls, testid }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <figure ref={ref} data-testid={testid} className={`group relative ${cls}`}>
      <div className="relative overflow-hidden aspect-[3/4] border border-[var(--line)] group-hover:border-[var(--gold)]/60 transition-colors duration-500">
        <motion.img style={{ y, scale: 1.18 }} src={src} alt={title} className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_40%,rgba(7,5,10,0.85))]" />
      </div>
      <figcaption className="mt-5 flex items-baseline justify-between">
        <span className="font-display text-2xl">{title}</span>
        <span className="font-mono text-xs tracking-widest uppercase text-[var(--gold)]">{tag}</span>
      </figcaption>
    </figure>
  );
};

const Sealed = ({ i }) => (
  <div data-testid={`work-placeholder-${i}`} className="relative aspect-[3/4] border border-dashed border-[var(--gold)]/30 bg-[var(--crypt)] grid place-items-center text-center p-6">
    <div>
      <Lock className="w-6 h-6 text-[var(--gold)] mx-auto" />
      <div className="font-display text-xl mt-4">New piece soon</div>
      <div className="font-mono text-xs text-[var(--ink-dim)] mt-2 tracking-widest uppercase">Vault opening</div>
    </div>
  </div>
);

export const Work = () => (
  <section id="work" data-testid="work-section" className="relative max-w-[1400px] mx-auto px-5 sm:px-10 py-28 sm:py-40">
    <Reveal>
      <Eyebrow n="03">The Work</Eyebrow>
      <SectionTitle>From the <span className="italic text-gilded">vault</span>.</SectionTitle>
      <p className="mt-6 max-w-xl text-[var(--ink-dim)] text-base sm:text-lg">
        Detailed, dramatic, one of one. A look at the style I bring to every commission.
      </p>
    </Reveal>
    <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
      <Reveal className="md:col-span-7"><Piece testid="work-piece-throne" src="/art/vamp-throne.jpg" title="Throne of the Vamp" tag="Graphic Art" /></Reveal>
      <Reveal delay={0.15} className="md:col-span-5 md:mt-40"><Piece testid="work-piece-arcane" src="/art/vamp-arcane.jpg" title="Arcane Night" tag="Character Art" /></Reveal>
    </div>
    <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
      {[1, 2, 3, 4].map((i) => <Reveal key={i} delay={i * 0.06}><Sealed i={i} /></Reveal>)}
    </div>
  </section>
);
